import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  DeleteInvoicesListPayloadType,
  GetAllExpensesInvoicesListPayloadType,
  GetAllRevenueInvoicesListPayloadType,
  EinvoiceDataPayloadType,
  EinvoiceRevertDataPayloadType,
  GetCommentPayloadType,
  EWayBillDataPayloadType,
  GenerateEWayBillPayloadType,
  EWayBillCancelDataPayloadType,
} from "../../../commonTypes/invoiceGenerationTypes";
import {
  TableHeader,
  ErrorSuccessModal,
  TableLoader,
  ConfirmationModal,
} from "../../commons";
import { REVENUES_INVOICES_LIST_HEADERS } from "../../../constant/tableHeadersConstants/invoiceGenerationConstants/invoicesListConst";
import {
  getAllRevenuInvoicesListAction,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetRevenueInvoicesList,
  getSingleInvoiceDetailsAction,
  resetSingleInvoiceDetails,
  deleteInvoiceAction,
  resetRevenueInvoicesTotal,
  resetSuccess,
  getReviewEinvoiceDataAction,
  postEinvoiceDataAction,
  postCancelEinvoiceDataAction,
  resetEinvoiceReviewData,
  resetEinvoiceError,
  getInvoiceCustomerInvoiceDownload,
  resetSingleInvoiceData,
  resetInvoiceGenerationOverDueEmailSuccess,
  getReviewEWayBillDataAction,
  resetEWayBillReviewData,
  getGenerateEWayBillAction,
  resetEWayBillError,
  cancelEWayBillDataAction,
} from "../../../redux/invoiceGeneration";
import { RootState } from "../../../redux/rootReducers";
import RevenueInvoicesListTableData from "./RevenueInvoicesListTableData";
import {
  EWayBillReviewDataType,
  EinvoiceReviewDataType,
} from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { resetSession } from "../../../redux/auth";

import {
  FILTER_PAYMENT_FORMAT_PURCHASE,
  OCR_FILTER,
  PAGINATION_INITIAL,
} from "../../../constant/invoiceListConst";

import { Row, Col } from "reactstrap";
import DownloadInvoiceGenerationReports from "../InvoiceGenerationReports";
import { SearchIcon } from "../../Icon";
import useDebounce from "../../../customHooks/useDebounce";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import Filter, {
  APPROVAL_RADIO_OPTIONS,
  ATTACHMENT_RADIO_OPTIONS,
  COMMENT_RADIO_OPTIONS,
  DATE_FILTER_OPTION,
} from "../Filter.tsx/Filter";
import {
  settingApproval,
  settingAttachment,
  settingComment,
} from "../../../utils/invoiceGeneration";
import ScrollToTop from "../../commons/ScrollToTop";
import MultiSelect from "../../commons/MultiSelect";
import { OptionsType, RadioTypes } from "../../../commonTypes/universalTypes";
import Sorting from "../Sorting/Sorting";
import PaymentSorting from "../PaymentSorting/PaymentSorting";
import LockEntryModal from "../LockEntryModal/LockEntryModal";
import toast from "react-hot-toast";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import EinvoiceModal from "../EinvoiceModal/EinvoiceModal";
import { REVERT_EINVOICE_OPTION } from "../EinvoiceModal/EinvoiceRevert";
import { SendInvoiceEmailData } from "../ExpenseEntry/ExpenseInvoicesList";
import RevenuePdfPreviewModal from "./RevenuePdfPreviewModal";
import InvoiceHistory from "../HistoryModal/InvoiceHistory";
import {
  GetAllLedgersListPayloadType,
  GetPdfMappingTemplatePayloadType,
  GetSingleCustomerSupplierListPayloadType,
  PdfTemplateMappingsType,
  PdfTemplateMappingType,
} from "../../../commonTypes/clientSettingsTypes";
import {
  getAllTypesWithTaxListAction,
  getMappedPdfTemplateAction,
  getSingleCustomerSupplierAction,
  resetMappedPdfTemplate,
  resetSingleCustomerSupplier,
} from "../../../redux/clientSettings";
import ViewEditCustomerSuplierModal from "../../Reports/LedgerStatement/ViewEditCustomerSuplierModal";
import { CustomerSupplierListType } from "../../../redux/clientSettings/clientSettingTypes";
import { formatDate, reverseDate } from "../../../utils/commonFunctions";
import EWayBillModal from "../EWayBillModal/EWayBillModal";
import { CANCEL_EWAYBILL_OPTION } from "../EWayBillModal/EWayBillCancel";

type AppProps = {
  token: string | null;
  client_code: number;
  history: any;
  company_name: string;
  message: string | null;
  fetching: boolean;
  bulkUploadFetching: boolean;
  pdfFetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  isRevenueHistory: boolean;
  eInvoiceError: string;
  eWayBillError: string;
  revenueInvoicesTotal: string | number;
  allRevenueInvoicesList: [] | any[];
  isAddSalesPresent: boolean;
  eInvoiceReviewData: EinvoiceReviewDataType | {};
  eWayBillReviewData: EWayBillReviewDataType;
  dispatchResetInvoiceGenerationErrorAction: () => void;
  dispatchGetPreviewEinvoiceData: (data: EinvoiceDataPayloadType) => void;
  dispatchGetPreviewEWayBillData: (data: EWayBillDataPayloadType) => void;
  dispatchPostEinvoiceDataAction: (data: EinvoiceDataPayloadType) => void;
  dispatchPostCancelEinvoiceDataAction: (
    data: EinvoiceRevertDataPayloadType
  ) => void;
  dispatchResetMessageAndSuccess: () => void;
  dispatchResetPreviewEinvoiceData: () => void;
  dispatchResetInvoiceGenerationSuccessAction: () => void;
  dispatchResetSession: () => void;
  dispatchResetRevenueInvoicesTotal: () => void;
  dispatchResetSingleInvoiceAction: () => void;
  dispatchGetSingleInvoiceAction: (data: GetCommentPayloadType) => void;
  dispatchResetRevenueInvoicesListAction: () => void;
  dispatchGetSingleInvoiceDetailsAction: (data: any) => void;
  singleInvoiceDetails: any | null;
  mappedRevenueColumnsList: any;
  handleSubmitLockEntry: (date: string) => void;
  dispatchResetSingleInvoiceDetails: () => void | null;
  dispatchResetEinvoiceError: () => void;
  dispatchResetEWayBillError: () => void;
  dispatchGetAllRevenuInvoicesListAction: (
    data: GetAllExpensesInvoicesListPayloadType
  ) => void;
  dispatchDeleteInvoice: (data: DeleteInvoicesListPayloadType) => void;
  loginData: LoginResponseType;
  isEditSalesPresent?: boolean;
  isEinvoice: boolean;
  isDownloadSalesPresent?: boolean;
  isDownloadSalesReportPresent?: boolean;
  isRevenueListCommentPresent?: boolean;
  currencySign: string | undefined;
  handleToggleInvoiceCommentsModal?: () => void;
  dispatchResetInvoiceGenerationOverDueEmailSuccess: () => void;
  handleSetInvoiceData: (data: any) => void;
  getInvoiceIdPdf: (data: number | null) => void;
  isViewSalesInvoicePresent?: boolean;
  showInvoiceCommentsModal: boolean;
  lockedRevenueEntriesDate: null | string;
  setShowSendInvoiceEmailModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleSendInvoiceEmailData: (data: SendInvoiceEmailData) => void;
  isBulkUploadSalesPresent?: boolean;
  customerSingleInvoiceData: any;
  currencyShortForm: string | undefined;
  toggleInvoiceHistory: (type: string, id?: number) => void;
  isInvoiceHistory: boolean;
  invoiceHistoryData: any;
  handleLoadMore: () => void;
  mappedPdfTemplate: PdfTemplateMappingsType | [];
  invoiceHistoryOffset: number;
  invoiceHistoryCount: number;
  invoiceHistoryLimit: number;
  dispatchGetAllTypesLedgerListAction: (
    data: GetAllLedgersListPayloadType
  ) => void;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchResetSingleCustomerSupplier: () => void;
  singleCustomerSupplier: CustomerSupplierListType;
  customerSuplierFetching: boolean;
  dispatchResetEWayBillReviewData: () => void;
  dispatchGetMappedPdfTemplateAction: (
    data: GetPdfMappingTemplatePayloadType
  ) => void;
  dispatchResetMappedPdfTemplateAction: () => void;
  dispatchGetGenerateEWayBillAction: (
    data: GenerateEWayBillPayloadType
  ) => void;
  dispatchCancelEWayBillDataAction: (
    data: EWayBillCancelDataPayloadType
  ) => void;
};

const RevenueInvoicesList = ({
  token,
  client_code,
  history,
  company_name,
  fetching,
  bulkUploadFetching,
  pdfFetching,
  success,
  message,
  error,
  statusCode,
  allRevenueInvoicesList,
  revenueInvoicesTotal,
  isRevenueHistory,
  getInvoiceIdPdf,
  mappedPdfTemplate,
  currencySign,
  isAddSalesPresent,
  dispatchResetSession,
  dispatchGetAllRevenuInvoicesListAction,
  dispatchGetMappedPdfTemplateAction,
  dispatchResetMappedPdfTemplateAction,
  dispatchResetInvoiceGenerationErrorAction,
  dispatchResetInvoiceGenerationSuccessAction,
  dispatchGetSingleInvoiceAction,
  dispatchResetRevenueInvoicesListAction,
  dispatchResetMessageAndSuccess,
  dispatchPostEinvoiceDataAction,
  dispatchResetPreviewEinvoiceData,
  dispatchPostCancelEinvoiceDataAction,
  dispatchResetEinvoiceError,
  dispatchResetEWayBillError,
  dispatchResetSingleInvoiceDetails,
  isEinvoice,
  dispatchDeleteInvoice,
  loginData,
  isEditSalesPresent,
  isDownloadSalesPresent,
  isDownloadSalesReportPresent,
  isRevenueListCommentPresent,
  handleToggleInvoiceCommentsModal,
  handleSetInvoiceData,
  isViewSalesInvoicePresent,
  dispatchResetRevenueInvoicesTotal,
  showInvoiceCommentsModal,
  handleSubmitLockEntry,
  lockedRevenueEntriesDate,
  eInvoiceReviewData,
  eWayBillReviewData,
  eInvoiceError,
  eWayBillError,
  dispatchGetPreviewEinvoiceData,
  dispatchGetPreviewEWayBillData,
  setShowSendInvoiceEmailModal,
  handleSendInvoiceEmailData,
  isBulkUploadSalesPresent,
  dispatchResetSingleInvoiceAction,
  customerSingleInvoiceData,
  dispatchResetInvoiceGenerationOverDueEmailSuccess,
  currencyShortForm,
  toggleInvoiceHistory,
  isInvoiceHistory,
  invoiceHistoryData,
  invoiceHistoryOffset,
  invoiceHistoryCount,
  handleLoadMore,
  invoiceHistoryLimit,
  dispatchGetAllTypesLedgerListAction,
  dispatchGetSingleCustomerSupplierAction,
  singleCustomerSupplier,
  customerSuplierFetching,
  dispatchResetEWayBillReviewData,
  dispatchGetGenerateEWayBillAction,
  dispatchCancelEWayBillDataAction,
}: AppProps) => {
  const persistSearch = history?.location?.state?.searchRevenueData;
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [pagination, setPagination] = useState(PAGINATION_INITIAL);
  const [showPreViewModal, setShowPreViewModal] = useState(false);
  const [selectedPdfId, setSelectedPdfId] = useState<any>(null);
  const [searchData, setSearchData] = useState(persistSearch);
  const [remove, setRemove] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [deleteInvoiceId, setDeleteInvoiceId] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);
  const [data, setData] = useState<any>([]);
  const [limit, setLimit] = useState<number>(20);
  const [searchClear, setSearchClear] = useState(false);
  const [attachment, setAttachment] = useState<string>("");
  const [approved, setApproved] = useState<string>("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [approvalValue, setApprovalValue] = useState<string>("");
  const [attachmentValue, setAttachmentValue] = useState<string>("");
  const [invoiceDataValue, setInvoiceDateValue] = useState<string>("");
  const [invoiceNumberValue, setInvoiceNumberValue] = useState<string>("");
  const [invoiceNumber, setInvoiceNumber] = useState<string>("");
  const [invoiceId, setInvoiceId] = useState<string>("");
  const [invoiceDate, setInvoiceDate] = useState<string>("");
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);
  const [comment, setComment] = useState<string>("");
  const [commentValue, setCommentValue] = useState<string>("");
  const [allSorting, setAllSorting] = useState("");
  const [allSortingValue, setAllSortingValue] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [allPaymentStatus, setAllPaymentStatus] = useState<number[]>([]);
  const [isLockRevenuePresent, setIsLockRevenuePresent] = useMenuCheck();
  const [isDeleteRevenueEntries, setIsDeleteRevenueEntries] = useMenuCheck();
  const [showPreviewEinvoiceModal, setShowPreviewEinvoiceModal] =
    useState(false);
  const [showPreviewEWayBillModal, setShowPreviewEWayBillModal] =
    useState(false);
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterStartDateValue, setFilterStartDateValue] = useState("");
  const [filterEndDateValue, setFilterEndDateValue] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
    const [isOCRFilter, setIsOCRFilter] = useState<boolean>(false);
    const [isOCRFilterValue, setIsOCRFilterValue] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [redirectToCustomerSuplier, setRedirectToCustomerSuplier] =
    useState<boolean>(false);
  const [isEditCustomerSupplierPresent, setIsEditCustomerSupplierPresent] =
    useMenuCheck();
  const [isEinvoicePresent, setIsEinvoicePresent] = useState<number>(0);
  const [isEWayPresent, setIsEWayPresent] = useState<number>(0);
  const [eInvoiceAt, setEinvoiceAt] = useState<string | null>(null);
  const [eWayBillAt, setEeWayBillAt] = useState<string | null>(null);
  const persistApproval = history?.location?.state?.revenueApproval;
  const persistAttachment = history?.location?.state?.revenueAttachement;
  const persistComment = history?.location?.state?.revenueComment;
  const persistIsOCRFilter= history?.location?.state?.isOcrFilter;

  const [cancelComment, setCancelComment] = useState<string>("");
  const [cancelEWayBillComment, setCancelEWayBillComment] =
    useState<string>("");
  const [downloadRevenuesData, setDownloadRevenuesData] = useState<any>(null);
  const [renderPdfModal, setRenderPdfModal] = useState(false);
  const [eInvoiceRadioValue, setEinvoiceRadioValue] = useState<string>(
    REVERT_EINVOICE_OPTION[0]?.id
  );
  const [eWayBillRadioValue, setEWayBillRadioValue] = useState<string>(
    CANCEL_EWAYBILL_OPTION[0]?.id
  );
  const [pdfTemplateSelected, setPdfTemplateSelected] = useState<OptionsType>({
    label: "Generic Pdf",
    value: "2343",
  });
  const [pdfTemplatesNames, setPdfTemplateNames] = useState<OptionsType[] | []>(
    []
  );
  const [pdfInvoiceId, setPdfInvoiceId] = useState<number | null>(null);
  const [isCancelEInvoicePresent, setIsCancelEInvoicePresent] = useMenuCheck();
  const [isGenerateEInvoicePresent, setIsGenerateEInvoicePresent] =
    useMenuCheck();
  const [isPreviewEInvoicePresent, setIsPreviewEInvoicePresent] =
    useMenuCheck();
  const [isEWayBillPresent, setIsEWayBillPresent] = useMenuCheck();
  const [isEWayBillGenerate, setIsEWayBillGenerate] = useMenuCheck();
  const [isEWayBillCancel, setIsEWayBillCancel] = useMenuCheck();
  const [isEWayBillExtend, setIsEWayBillExtend] = useMenuCheck();
  const [isEWayBillDownload, setIsEWayBillDownload] = useMenuCheck();

  const [filterInvoiceStartDate, setFilterInvoiceStartDate] = useState("");
  const [filterInvoiceEndDate, setFilterInvoiceEndDate] = useState("");
  const [filterInvoiceStartDateValue, setFilterInvoiceStartDateValue] =
    useState("");
  const [filterInvoiceEndDateValue, setFilterInvoiceEndDateValue] =
    useState("");
  const [radioValue, setRadioValue] = useState(DATE_FILTER_OPTION[0].id);

  const persistInvoiceRevenueDateSorting =
    history?.location?.state?.invoiceRevenueDataValue;
  const persistInvoiceNumberRevenueSorting =
    history?.location?.state?.invoiceNumberRevenueValue;
  let persistRevenuePaymentStatus =
    history?.location?.state?.allPaymentStatusRevenue;
  const persistFilterStartDate = history?.location?.state?.revenuestartDate;
  const persistFilterEndDate = history?.location?.state?.revenueendDate;
  const persistFilterRadioButton = history?.location?.state?.revenueRadioValue;
  const persistFilterInvoiceStartDate =
    history?.location?.state?.revenueInvoiceStartDate;
  const persistFilterInvoiceEndDate =
    history?.location?.state?.revenueInvoiceEndDate;

  if (history?.location?.state?.searchRevenueData) {
    delete history?.location?.state?.searchRevenueData;
  }

  const [generateEWayBill, setGenerateEWayBill] =
    useState<GenerateEWayBillPayloadType>({
      token,
      client_code: null,
      invoice_id: null,
      invoice_type: "revenues", // expenses or revenues,
      sub_supply_type: "",
      transporter_id: "", //GST of transporter
      transporter_name: "",
      transporter_document_number: "",
      transporter_document_date: "",
      transportation_mode: "",
      transportation_distance: "",
      vehicle_number: "",
      vehicle_type: "",
      transaction_type: "Regular",
      type: "revenues",
    });
  const [eWayBillInvoiceId, setEWayBillInvoiceId] = useState("");
  useEffect(() => {
    if (
      persistApproval?.length > 0 ||
      persistAttachment?.length > 0 ||
      persistComment?.length > 0 ||
      persistFilterStartDate?.length > 0 ||
      persistFilterEndDate?.length > 0 ||
      persistFilterInvoiceEndDate?.length > 0 ||
      persistFilterInvoiceStartDate?.length > 0 ||
      persistFilterRadioButton?.length > 0
      || persistIsOCRFilter > 0
    ) {
      setApproved(persistApproval);
      setAttachment(persistAttachment);
      setApprovalValue(persistApproval);
      setAttachmentValue(persistAttachment);
      setCommentValue(persistComment);
      setComment(persistComment);
      setFilterStartDateValue(persistFilterStartDate);
      setFilterStartDate(persistFilterStartDate);
      setFilterEndDateValue(persistFilterEndDate);
      setFilterEndDate(persistFilterEndDate);
      setFilterInvoiceEndDateValue(persistFilterInvoiceEndDate);
      setFilterInvoiceEndDate(persistFilterInvoiceEndDate);
      setFilterInvoiceStartDateValue(persistFilterInvoiceStartDate);
      setFilterInvoiceStartDate(persistFilterInvoiceStartDate);
      setRadioValue(persistFilterRadioButton);
      setIsOCRFilterValue(persistIsOCRFilter);
    }
  }, [
    persistApproval,
    persistAttachment,
    persistComment,
    persistFilterStartDate,
    persistFilterEndDate,
    persistFilterInvoiceStartDate,
    persistFilterInvoiceEndDate,
    persistFilterRadioButton,
    persistIsOCRFilter
  ]);

  useEffect(() => {
    dispatchResetMappedPdfTemplateAction();
    let mappedFinalData = {
      token,
      clientCode: client_code,
      invoiceType: "revenues",
    };
    dispatchGetMappedPdfTemplateAction(mappedFinalData);
  }, []);

  useEffect(() => {
    if (eWayBillReviewData?.VehiclListDetails?.length) {
      setEeWayBillAt(
        eWayBillReviewData?.VehiclListDetails[0]?.vehicle_number_update_date
      );
    } else {
      setEeWayBillAt(null);
    }
  }, [eWayBillReviewData]);

  useEffect(() => {
    if (persistRevenuePaymentStatus?.length > 0) {
      let newActiveStatus = persistRevenuePaymentStatus.join(",")?.toString();
      setAllPaymentStatus(persistRevenuePaymentStatus);
      setPaymentStatus(newActiveStatus);
      setIsMultiSelectPresent(true);
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [persistRevenuePaymentStatus]);

  useEffect(() => {
    if (persistRevenuePaymentStatus?.length > 0) {
      let newActiveStatus = persistRevenuePaymentStatus.join(",")?.toString();
      setAllPaymentStatus(persistRevenuePaymentStatus);
      setPaymentStatus(newActiveStatus);
      setIsMultiSelectPresent(true);
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [persistRevenuePaymentStatus]);

  useEffect(() => {
    dispatchResetSingleInvoiceAction();
    dispatchResetInvoiceGenerationOverDueEmailSuccess();
    setDownloadRevenuesData([]);
    dispatchResetEWayBillReviewData();
    handleDeleteFiltersInHistory();
    setIsLockRevenuePresent("Lock Sales Invoicing Advance", "menu");
    setIsDeleteRevenueEntries("Delete Revenue Entries", "menu");
    setIsCancelEInvoicePresent("Cancel E-invoice", "menu");
    setIsGenerateEInvoicePresent("Generate E-invoice", "menu");
    setIsPreviewEInvoicePresent("Review E-invoice", "menu");
    setIsEWayBillPresent("E-Way bill sales", "menu");
    setIsEWayBillGenerate("Generate E-way bill sales", "menu");
    setIsEWayBillCancel("Cancel E-Way bill sales", "menu");
    setIsEWayBillExtend("Extend E-Way bill revenues", "menu");
    setIsEWayBillDownload("E-Way bill sales download", "menu");
    setIsEditCustomerSupplierPresent("Edit Customer/Supplier", "menu");
    dispatchResetPreviewEinvoiceData();

    setAllSortingValue("deafult");
    if (
      persistInvoiceRevenueDateSorting === "invoice_date_asc" ||
      persistInvoiceRevenueDateSorting === "invoice_date_desc"
    ) {
      setInvoiceDateValue(persistInvoiceRevenueDateSorting);
      setInvoiceDate(persistInvoiceRevenueDateSorting);
      setInvoiceNumberValue("");
      setInvoiceNumber("");
      setAllSortingValue(persistInvoiceRevenueDateSorting);
    } else if (
      persistInvoiceNumberRevenueSorting === "invoice_number_asc" ||
      persistInvoiceNumberRevenueSorting === "invoice_number_desc"
    ) {
      setInvoiceNumberValue(persistInvoiceNumberRevenueSorting);
      setInvoiceNumber(persistInvoiceNumberRevenueSorting);
      setInvoiceDate("");
      setInvoiceDateValue("");
      setAllSortingValue(persistInvoiceNumberRevenueSorting);
    } else {
      setAllSortingValue("default");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (allPaymentStatus?.includes(10)) {
      setPaymentStatus("");
    } else {
      setPaymentStatus(allPaymentStatus.join(","));
    }
  }, [allPaymentStatus]);

  useEffect(() => {
    if (success === 1 && !!message && message === "client has been locked ") {
      fetchNewData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, message]);

  useEffect(() => {
    setIsEdit(false);
    dispatchResetInvoiceGenerationErrorAction();
    dispatchResetInvoiceGenerationSuccessAction();
    dispatchResetRevenueInvoicesListAction();
    dispatchResetSingleInvoiceDetails();
    dispatchResetRevenueInvoicesTotal();
    setIsMultiSelectPresent(false);
    const { location: { search = "" } = {} } = window;

    let pageNum;

    if (search) {
      const params = new URLSearchParams(search);
      pageNum = Number(params.get("page")) || 0;
    }
    if (remove && offset === 0) {
      if (token && client_code) {
        let finalData: GetAllRevenueInvoicesListPayloadType = {
          token,
          client_code,
          limit: 10,
          search_value: searchData,
          offset: pageNum ? pageNum * 10 : 0,
          attachment: attachment ? attachment : persistAttachment,
          approved: approved ? approved : persistApproval,
          invoiceDate,
          invoiceNumber,
          paymentStatus,
          comment: comment ? comment : persistComment,
          created_at_start_date: filterStartDate
            ? formatDate(filterStartDate)
            : persistFilterStartDate
              ? formatDate(persistFilterStartDate)
              : "",
          created_at_end_date: filterEndDate
            ? formatDate(filterEndDate)
            : persistFilterEndDate
              ? formatDate(persistFilterEndDate)
              : "",
          invoice_date_start_date: filterInvoiceStartDate
            ? formatDate(filterInvoiceStartDate)
            : persistFilterInvoiceStartDate
              ? formatDate(persistFilterInvoiceStartDate)
              : "",
          invoice_date_end_date: filterInvoiceEndDate
            ? formatDate(filterInvoiceEndDate)
            : persistFilterInvoiceEndDate
              ? formatDate(persistFilterInvoiceEndDate)
              : "",
            is_invoice_ocr_created: persistIsOCRFilter?1:isOCRFilterValue ? 1 : 0,
        };

        dispatchGetAllRevenuInvoicesListAction(finalData);
      }
    } else if (offset > 0) {
      setOffset(0);
    }
    setRemove(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remove]);

  useEffect(() => {
    if (mappedPdfTemplate?.length > 0) {

      let pdfTemplateOptions = mappedPdfTemplate?.map(
        (pdfTemplate: PdfTemplateMappingType) => {
          if (pdfTemplate?.is_default) {

            setPdfTemplateSelected({
              label: pdfTemplate?.pdf_template_name,
              value: pdfTemplate?.pdf_template_id,
            });
          }
          return {
            label: pdfTemplate?.pdf_template_name,
            value: pdfTemplate?.pdf_template_id,
          };
        }
      );
      setPdfTemplateNames([...pdfTemplateOptions]);
    } else {
      setPdfTemplateSelected({
        label: "Generic Pdf",
        value: "2343",
      })
      setPdfTemplateNames([])
    }
  }, [mappedPdfTemplate]);

  useEffect(() => {
    if (allRevenueInvoicesList?.length === 0) {
      setData([...allRevenueInvoicesList]);
    }
    if (offset === 0) {
      setData([...allRevenueInvoicesList]);
    } else if (offset > 0) {
      setData((prv: any) => [...prv, ...allRevenueInvoicesList]);
    } else {
      setData([...allRevenueInvoicesList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRevenueInvoicesList]);

  useEffect(() => {
    if (token && client_code && !showInvoiceCommentsModal) {
      let finalData: GetAllRevenueInvoicesListPayloadType = {
        token,
        client_code,
        limit,
        offset,
        search_value: searchData,
        attachment: attachment ? attachment : persistAttachment,
        comment: comment ? comment : persistComment,
        approved: approved ? approved : persistApproval,
        invoiceDate: invoiceDate
          ? invoiceDate
          : persistInvoiceRevenueDateSorting,
        invoiceNumber: invoiceNumber
          ? invoiceNumber
          : persistInvoiceNumberRevenueSorting,
        paymentStatus: paymentStatus
          ? paymentStatus
          : persistRevenuePaymentStatus
            ? `${[...persistRevenuePaymentStatus]}`
            : "",
        created_at_start_date: filterStartDate
          ? formatDate(filterStartDate)
          : persistFilterStartDate
            ? formatDate(persistFilterStartDate)
            : "",
        created_at_end_date: filterEndDate
          ? formatDate(filterEndDate)
          : persistFilterEndDate
            ? formatDate(persistFilterEndDate)
            : "",
        invoice_date_start_date: filterInvoiceStartDate
          ? formatDate(filterInvoiceStartDate)
          : persistFilterInvoiceStartDate
            ? formatDate(persistFilterInvoiceStartDate)
            : "",
        invoice_date_end_date: filterInvoiceEndDate
          ? formatDate(filterInvoiceEndDate)
          : persistFilterInvoiceEndDate
            ? formatDate(persistFilterInvoiceEndDate)
            : "",
            is_invoice_ocr_created: isOCRFilterValue ? 1 : persistIsOCRFilter ? 1 : 0,
      };

      if (offset < +revenueInvoicesTotal) {
        dispatchGetAllRevenuInvoicesListAction(finalData);
      } else if (
        offset === 0 &&
        (revenueInvoicesTotal === "" || +revenueInvoicesTotal === 0)
      ) {
        dispatchGetAllRevenuInvoicesListAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, showInvoiceCommentsModal]);

  useEffect(() => {
    if (!showInvoiceCommentsModal) {
      window.scrollTo(0, 0);
      if (offset === 0) {
      } else {
        dispatchResetRevenueInvoicesListAction();
        dispatchResetRevenueInvoicesTotal();
        setOffset(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showInvoiceCommentsModal]);

  useEffect(() => {
    if (clearFilter) {
      if (token && client_code) {
        let finalData: GetAllRevenueInvoicesListPayloadType = {
          token,
          client_code,
          limit,
          offset,
          search_value: searchData,
          attachment: attachment ? attachment : persistAttachment,
          approved: approved ? approved : persistApproval,
          invoiceDate,
          invoiceNumber,
          paymentStatus,
          comment: comment ? comment : persistComment,
          created_at_start_date: filterStartDate
            ? formatDate(filterStartDate)
            : persistFilterStartDate
              ? formatDate(persistFilterStartDate)
              : "",
          created_at_end_date: filterEndDate
            ? formatDate(filterEndDate)
            : persistFilterEndDate
              ? formatDate(persistFilterEndDate)
              : "",
          invoice_date_start_date: filterInvoiceStartDate
            ? formatDate(filterInvoiceStartDate)
            : persistFilterInvoiceStartDate
              ? formatDate(persistFilterInvoiceStartDate)
              : "",
          invoice_date_end_date: filterInvoiceEndDate
            ? formatDate(filterInvoiceEndDate)
            : persistFilterInvoiceEndDate
              ? formatDate(persistFilterInvoiceEndDate)
              : "",
              // is_invoice_ocr_created: persistIsOCRFilter ? persistIsOCRFilter: isOCRFilterValue ? 1 : 0,
        };
        dispatchGetAllRevenuInvoicesListAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFilter]);

  useEffect(() => {
    if (
      success === 1 &&
      !!message &&
      message === "E-Way Bill created successfully"
    ) {
      let finalData = {
        token,
        client_code,
        invoice_id: +eWayBillInvoiceId,
        invoice_type: "revenues",
        type: "revenues",
      };

      dispatchResetMessageAndSuccess();
      toast.success("E-Way Bill created successfully!", {
        duration: 2000,
      });
      fetchNewData();
      dispatchGetPreviewEWayBillData(finalData);
      // setShowPreviewEWayBillModal((prev: boolean) => !prev);
    }

    if (
      success === 1 &&
      !!message &&
      message === "E-Way Bill has been extended successfully"
    ) {
      let finalData = {
        token,
        client_code,
        invoice_id: +eWayBillInvoiceId,
        invoice_type: "revenues",
        type: "revenues",
      };

      dispatchResetMessageAndSuccess();
      toast.success("E-Way Bill has been extended successfully!", {
        duration: 2000,
      });
      fetchNewData();
      dispatchGetPreviewEWayBillData(finalData);
      // setShowPreviewEWayBillModal((prev: boolean) => !prev);
    }

    if (
      success === 1 &&
      !!message &&
      message === "E-Way Bill has been cancelled successfully"
    ) {
      let finalData = {
        token,
        client_code,
        invoice_id: +eWayBillInvoiceId,
        invoice_type: "revenues",
        type: "revenues",
      };

      dispatchResetMessageAndSuccess();
      toast.success("E-Way Bill has been cancelled successfully!", {
        duration: 2000,
      });
      fetchNewData();
      dispatchGetPreviewEWayBillData(finalData);
      // setShowPreviewEWayBillModal((prev: boolean) => !prev);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  useEffect(() => {
    dispatchResetRevenueInvoicesListAction();
    dispatchResetRevenueInvoicesTotal();
    setData([]);
    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (attachment && isMultiSelectPresent) ||
      (approved && isMultiSelectPresent) ||
      (paymentStatus?.length && isMultiSelectPresent) ||
      (!approved && isMultiSelectPresent) ||
      (!attachment && isMultiSelectPresent) ||
      (!paymentStatus?.length && !isMultiSelectPresent) ||
      ((!isOCRFilterValue || isOCRFilterValue)&& isMultiSelectPresent) ||
        (!isOCRFilterValue && !isMultiSelectPresent)
    ) {
      if (offset === 0) {
        let finalData: GetAllRevenueInvoicesListPayloadType = {
          token,
          client_code,
          limit,
          offset,
          search_value: searchData,
          attachment: attachment ? attachment : persistAttachment,
          comment: comment ? comment : persistComment,
          approved: approved ? approved : persistApproval,
          invoiceDate: invoiceDate
            ? invoiceDate
            : persistInvoiceRevenueDateSorting,
          invoiceNumber: invoiceNumber
            ? invoiceNumber
            : persistInvoiceNumberRevenueSorting,
          paymentStatus: paymentStatus
            ? paymentStatus
            : persistRevenuePaymentStatus
              ? `${[...persistRevenuePaymentStatus]}`
              : "",
          created_at_start_date: filterStartDate
            ? formatDate(filterStartDate)
            : persistFilterStartDate
              ? formatDate(persistFilterStartDate)
              : "",
          created_at_end_date: filterEndDate
            ? formatDate(filterEndDate)
            : persistFilterEndDate
              ? formatDate(persistFilterEndDate)
              : "",
          invoice_date_start_date: filterInvoiceStartDate
            ? formatDate(filterInvoiceStartDate)
            : persistFilterInvoiceStartDate
              ? formatDate(persistFilterInvoiceStartDate)
              : "",
          invoice_date_end_date: filterInvoiceEndDate
            ? formatDate(filterInvoiceEndDate)
            : persistFilterInvoiceEndDate
              ? formatDate(persistFilterInvoiceEndDate)
              : "",
              is_invoice_ocr_created: isOCRFilterValue ? 1 : persistIsOCRFilter ? 1 : 0,
        };
        dispatchGetAllRevenuInvoicesListAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    attachment,
    approved,
    invoiceDate,
    invoiceNumber,
    paymentStatus,
    comment,
    filterStartDate,
    filterEndDate,
    filterInvoiceStartDate,
    filterInvoiceEndDate,
    isOCRFilterValue
  ]);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (
      offset < +revenueInvoicesTotal &&
      !fetching &&
      Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
    ) {
      if (allRevenueInvoicesList?.length > 0) {
        if (!fetching && offset < +revenueInvoicesTotal) {
          setOffset(offset + limit);
        }
      }
    }
  };

  useEffect(() => {
    if (
      !!customerSingleInvoiceData &&
      Object.keys(customerSingleInvoiceData)?.length
    ) {
      setDownloadRevenuesData(customerSingleInvoiceData);
    }
  }, [customerSingleInvoiceData]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRevenueInvoicesList]);

  const handleRedirectToEditForm = (data: any) => {
    history.push({
      pathname: `/invoice-generation/edit/${data?.id}/${client_code}?type=revenues`,
      state: {
        client_code,
        company_name,
        data,
        isEdit,
        attachment,
        approved,
        searchRevenueData: searchData,
        invoiceRevenueDataValue: invoiceDataValue,
        invoiceNumberRevenueValue: invoiceNumberValue,
        allPaymentStatusRevenue: allPaymentStatus,
        comment,
        filterStartDate,
        filterEndDate,
        filterInvoiceStartDate,
        filterInvoiceEndDate,
        radioValue,
        isOCRFilterValue
      },
    });
  };

  const handleDeleteFiltersInHistory = () => {
    delete history?.location?.state?.approval;
    delete history?.location?.state?.attachment;
    delete history?.location?.state?.isOCRFilter
  };

  const handleRedirectToCopyForm = (data: any) => {
    history.push({
      pathname: `/invoice-generation/copy/${data?.id}/${client_code}?type=revenues`,
      state: { client_code, company_name, data, isEdit, offset },
    });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type={
              !!error &&
                error.includes(
                  "Columns are not assigned to you. Please contact administrator!"
                )
                ? "warning"
                : "error"
            }
            isOpen={!!error}
            title={
              !!error &&
                error.includes(
                  "Columns are not assigned to you. Please contact administrator!"
                )
                ? "Info"
                : "Error"
            }
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationErrorAction();
              dispatchResetMessageAndSuccess();
            }}
          />
        );
      }
    } else {
      if (success === 1 && !!message && message === "client has been locked ") {
        dispatchResetMessageAndSuccess();
        toast.success("Entries has been locked successfully!", {
          duration: 2000,
        });
      }
      if (
        success === 1 &&
        !!message &&
        (message === "E-inovcing created successfully" ||
          message === "e-invoice has been cancelled successfully")
      ) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={
              message === "E-inovcing created successfully"
                ? "E-Invoicing Created Successfully!"
                : message === "e-invoice has been cancelled successfully"
                  ? "E-Invoicing Cancelled Successfully!"
                  : null
            }
            buttonText="OK"
            onPress={() => {
              fetchNewData();
              dispatchResetMessageAndSuccess();
            }}
            statusCode={statusCode}
          />
        );
      }
    }

    return false;
  };

  const togglePreviewEInvoice = (data?: any) => {
    dispatchResetEinvoiceError();
    dispatchResetPreviewEinvoiceData();
    setInvoiceId("");
    setIsEinvoicePresent(0);
    setEinvoiceAt(null);
    if (data?.id) {
      setInvoiceId(data?.id);
      setIsEinvoicePresent(data?.einvoicing_status);
      setEinvoiceAt(data?.einvoicing_at);
      let finalData = {
        token,
        client_code,
        invoice_id: +data?.id,
      };
      dispatchGetPreviewEinvoiceData(finalData);
    }

    history.push({
      pathname: `/invoice-generation/e-invoice/${client_code}?type=revenues`,
      state: {
        client_code,
        company_name,
        invoiceId: +data?.id,
        eInvoiceStatus: data?.einvoicing_status,
        eInvoiceAt: data?.einvoicing_at,
      },
    });
    // setShowPreviewEinvoiceModal((prev: boolean) => !prev);
  };

  const togglePreviewEWayBill = (data: any) => {
    dispatchResetEWayBillReviewData();
    setIsEWayPresent(0);
    dispatchResetEWayBillError();
    // setEeWayBillAt(null);
    setGenerateEWayBill({
      token,
      client_code: null,
      invoice_id: null,
      invoice_type: "revenues",
      type: "revenues",
      sub_supply_type: "",
      transporter_id: "",
      transporter_name: "",
      transporter_document_number: "",
      transporter_document_date: "",
      transportation_mode: "",
      transportation_distance: "",
      vehicle_number: "",
      vehicle_type: "",
      transaction_type: "Regular",
    });
    if (data?.id) {
      setEWayBillInvoiceId(data?.id);
      let finalData = {
        token,
        client_code,
        invoice_id: +data?.id,
        invoice_type: "revenues",
        type: "revenues",
      };

      // dispatchGetPreviewEWayBillData(finalData);
    }

    history.push({
      pathname: `/invoice-generation/e-way-bill/${client_code}?type=revenues`,
      state: {
        client_code,
        company_name,
        invoiceId: +data?.id,
        eInvoiceStatus: data?.e_way_bill_status,
        eInvoiceAt: data?.e_way_bill_generated_at,
        type: "revenues",
      },
    });
  };

  const fetchNewData = () => {
    if (token) {
      setSearchClear(true);
      let finalData = {
        token,
        client_code,
        offset: 0,
        limit,
        search_value: searchData,
        attachment: attachment ? attachment : persistAttachment,
        comment: comment ? comment : persistComment,
        approved: approved ? approved : persistApproval,
        invoiceDate: invoiceDate
          ? invoiceDate
          : persistInvoiceRevenueDateSorting,
        invoiceNumber: invoiceNumber
          ? invoiceNumber
          : persistInvoiceNumberRevenueSorting,
        paymentStatus: paymentStatus
          ? paymentStatus
          : persistRevenuePaymentStatus
            ? `${[...persistRevenuePaymentStatus]}`
            : "",
        created_at_start_date: filterStartDate
          ? formatDate(filterStartDate)
          : persistFilterStartDate
            ? formatDate(persistFilterStartDate)
            : "",
        created_at_end_date: filterEndDate
          ? formatDate(filterEndDate)
          : persistFilterEndDate
            ? formatDate(persistFilterEndDate)
            : "",
        invoice_date_start_date: filterInvoiceStartDate
          ? formatDate(filterInvoiceStartDate)
          : persistFilterInvoiceStartDate
            ? formatDate(persistFilterInvoiceStartDate)
            : "",
        invoice_date_end_date: filterInvoiceEndDate
          ? formatDate(filterInvoiceEndDate)
          : persistFilterInvoiceEndDate
            ? formatDate(persistFilterInvoiceEndDate)
            : "",
              is_invoice_ocr_created: isOCRFilterValue ? 1 : persistIsOCRFilter ? 1 : 0,
      };
      if (offset === 0) {
        setOffset(0);
        dispatchGetAllRevenuInvoicesListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  useEffect(() => {
    if (searchClear) {
      let finalData = {
        token,
        search_term: searchData,
        client_code,
        limit,
        offset,
        attachment: attachment ? attachment : persistAttachment,
        comment: comment ? comment : persistComment,
        approved: approved ? approved : persistApproval,
        invoiceDate,
        invoiceNumber,
        paymentStatus,
        created_at_start_date: filterStartDate
          ? formatDate(filterStartDate)
          : persistFilterStartDate
            ? formatDate(persistFilterStartDate)
            : "",
        created_at_end_date: filterEndDate
          ? formatDate(filterEndDate)
          : persistFilterEndDate
            ? formatDate(persistFilterEndDate)
            : "",
        invoice_date_start_date: filterInvoiceStartDate
          ? formatDate(filterInvoiceStartDate)
          : persistFilterInvoiceStartDate
            ? formatDate(persistFilterInvoiceStartDate)
            : "",
        invoice_date_end_date: filterInvoiceEndDate
          ? formatDate(filterInvoiceEndDate)
          : persistFilterInvoiceEndDate
            ? formatDate(persistFilterInvoiceEndDate)
            : "",
            is_invoice_ocr_created: isOCRFilterValue ? 1 : persistIsOCRFilter ? persistIsOCRFilter: 0,
      };
      if (searchData?.length === 0) {
        dispatchResetRevenueInvoicesListAction();
        dispatchGetAllRevenuInvoicesListAction(finalData);
        setOffset(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchClear, searchData]);

  const handleGeneratePdf = (data: any) => {
    setSelectedPdfId(data);
    setPdfInvoiceId(data?.id);
    setShowPreViewModal(!showPreViewModal);
  };

  const handleShowPdfPreviewModal = () => {
    setShowPreViewModal(!showPreViewModal);
  };

  const handleNewInvoicePdf = (data: any) => {
    getInvoiceIdPdf(data?.id);
    setDownloadRevenuesData([]);
    dispatchResetSingleInvoiceAction();
    let finalData: GetCommentPayloadType = {
      type: "revenues",
      token,
      invoice_id: data?.id ? data?.id : data?.others_id,
      client_code,
    };
    dispatchGetSingleInvoiceAction(finalData);
    setRenderPdfModal(true);
  };

  const handleShowConfirmationModal = (id: number) => {
    setShowConfirmationModal(!showConfirmationModal);
    setDeleteInvoiceId(id);
  };
  const onClose = (id: any) => {
    let newid = id.split("_")[0];
    if (newid === "Att") {
      delete history?.location?.state?.revenueAttachement;
    }
    if (newid === "App") {
      delete history?.location?.state?.revenueApproval;
    }
    if (
      id === "payment4" ||
      id === "payment3" ||
      id === "payment2" ||
      id === "payment5"
    ) {
      delete history?.location?.state?.allPaymentStatusRevenue;
    }
    if (newid === "Comm") {
      delete history?.location?.state?.revenueComment;
    }

      if(id==="ocr"){
      delete history?.location?.state?.isOcrFilter;
      setIsOCRFilterValue(false);
      setIsOCRFilter(false);
    }

    const checkAttachmentValue = ATTACHMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?._id === id
    );
    const checkCommentValue = COMMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?._id === id
    );
    const checkApprovedValue = APPROVAL_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?._id === id
    );
    const checkPaymentValue = FILTER_PAYMENT_FORMAT_PURCHASE?.find(
      (item: any) => item?._id === id
    );

    if (checkAttachmentValue) {
      setAttachment("");
      setAttachmentValue("");
    }
    if (checkCommentValue) {
      setComment("");
      setCommentValue("");
    }
    if (id === "startDate") {
      setFilterStartDate("");
      setFilterStartDateValue("");
      setFilterEndDate("");
      setFilterEndDateValue("");
      setFilterInvoiceEndDate("");
      setFilterInvoiceStartDate("");
      setFilterInvoiceEndDateValue("");
      setFilterInvoiceStartDateValue("");
      delete history?.location?.state?.revenuestartDate;
      delete history?.location?.state?.revenueendDate;
      delete history?.location?.state?.revenueInvoiceStartDate;
      delete history?.location?.state?.revenueInvoiceEndDate;
      delete history?.location?.state?.revenueRadioValue;
      setRadioValue(DATE_FILTER_OPTION[0].id);
    }

    if (checkApprovedValue) {
      setApproved("");
      setApprovalValue("");
    }
    if (checkPaymentValue) {
      const removePaymentValue = allPaymentStatus?.filter(
        (item: any) => item != checkPaymentValue?.value
      );
      setAllPaymentStatus([...removePaymentValue]);
    }
  };

  const handleSubmitPreviewEinvoice = (type: string) => {
    if (type === "submit") {
      let payload = {
        client_code,
        token,
        invoice_id: +invoiceId,
      };
      dispatchPostEinvoiceDataAction(payload);
    } else if (type == "revert") {
      let payload = {
        client_code,
        token,
        invoice_id: +invoiceId,
        cancel_reason: eInvoiceRadioValue,
        cancel_remarks: cancelComment,
      };
      dispatchPostCancelEinvoiceDataAction(payload);
    }
  };

  const handleCancelEWayBill = () => {
    let payload = {
      client_code,
      token,
      invoice_type: "revenues",
      invoice_id: +eWayBillInvoiceId,
      reason_of_cancel: eWayBillRadioValue,
      cancel_remarks: cancelEWayBillComment,
      type: "revenues",
    };
    dispatchCancelEWayBillDataAction(payload);
  };

  const getData = useCallback(() => {
    const getAttachmentValue = ATTACHMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item.id === attachment
    );
    const getCommentValue = COMMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?.id === comment
    );
    const getApprovedValue = APPROVAL_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item.id === approved
    );
    const getPaymentValue = FILTER_PAYMENT_FORMAT_PURCHASE?.filter(
      (el: any, index: number) => {
        if (allPaymentStatus?.includes(+el?.value) && el?.value != 10) {
          return el;
        }
      }
    );
    
        const isOCRFilterValueData :any= OCR_FILTER.find(
          (item) => String(item?.id) === String(isOCRFilterValue?1:0)
        );
    if (getPaymentValue?.length === 0) {
      setMultiSelectData([
        isOCRFilterValueData,
        getAttachmentValue,
        getCommentValue,
        {
          name:
            radioValue === "1"
              ? `${filterStartDate ? `Creation Date` : ""} ${filterStartDate ? formatDate(filterStartDate) : ""
              } ${filterStartDate ? `to` : ""} ${filterEndDate ? formatDate(filterEndDate) : ""
              }`
              : `${filterInvoiceStartDate ? `Invoice Date` : ""} ${filterInvoiceStartDate
                ? formatDate(filterInvoiceStartDate)
                : ""
              } ${filterInvoiceStartDate ? `to` : ""} ${filterInvoiceEndDate ? formatDate(filterInvoiceEndDate) : ""
              }`,
          _id: "startDate",
        },
        getApprovedValue,
        undefined,
      ]);
    } else {
      let allStatusValues = allPaymentStatus?.includes(10);
      if (allStatusValues) {
        setMultiSelectData([
          getAttachmentValue,
          getCommentValue,
          {
            name:
              radioValue === "1"
                ? `${filterStartDate ? `Creation Date` : ""} ${filterStartDate ? formatDate(filterStartDate) : ""
                } ${filterStartDate ? `to` : ""} ${filterEndDate ? formatDate(filterEndDate) : ""
                }`
                : `${filterInvoiceStartDate ? `Invoice Date` : ""} ${filterInvoiceStartDate
                  ? formatDate(filterInvoiceStartDate)
                  : ""
                } ${filterInvoiceStartDate ? `to` : ""} ${filterInvoiceEndDate ? formatDate(filterInvoiceEndDate) : ""
                }`,
            _id: "startDate",
          },
          getApprovedValue,
        ]);
      } else {
        setMultiSelectData([
          isOCRFilterValueData,
          getAttachmentValue,
          getCommentValue,
          getApprovedValue,
          ...getPaymentValue,
          {
            name:
              radioValue === "1"
                ? `${filterStartDate ? `Creation Date` : ""} ${filterStartDate ? formatDate(filterStartDate) : ""
                } ${filterStartDate ? `to` : ""} ${filterEndDate ? formatDate(filterEndDate) : ""
                }`
                : `${filterInvoiceStartDate ? `Invoice Date` : ""} ${filterInvoiceStartDate
                  ? formatDate(filterInvoiceStartDate)
                  : ""
                } ${filterInvoiceStartDate ? `to` : ""} ${filterInvoiceEndDate ? formatDate(filterInvoiceEndDate) : ""
                }`,
            _id: "startDate",
          },
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    attachment,
    approved,
    paymentStatus,
    comment,
    filterStartDate,
    filterEndDate,
    filterInvoiceStartDate,
    filterInvoiceEndDate,
    isOCRFilterValue
  ]);

  const handleSearch = (e: any) => {
    let value = e?.target?.value;
    setSearchData(value);
  };

  const deleteInvoice = (invoice_id: number) => {
    let data = {
      invoice_id,
      type: "revenues",
      token,
      client_code,
    };
    dispatchDeleteInvoice(data);
    setRemove(true);
    window.scrollTo(0, 0);
  };

  const handleCustomerSuppliertoggle = () => {
    setShowModal(!showModal);
    if (redirectToCustomerSuplier) {
      if (token && client_code) {
        dispatchGetAllTypesLedgerListAction({ client_code, token });
      }
    }
  };
  const handleCustomerSuplierDetailsData = (data: number) => {
    setShowModal(!showModal);
    if (token && client_code) {
      const finaldata = {
        token,
        client_code,
        customerSupplierId: data,
      };
      dispatchGetSingleCustomerSupplierAction(finaldata);
    }
  };
  // Custom Hook for debounce function
  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
        setPagination(PAGINATION_INITIAL);
      }
    },
    500,
    [searchData]
  );

  const handleEWayBillGenerate = () => {
    dispatchResetEWayBillError();
    const finalData = {
      ...generateEWayBill,
      transactionType:
        generateEWayBill?.transaction_type === "Regular"
          ? 1
          : generateEWayBill?.transaction_type === "Bill/Ship To"
            ? 2
            : generateEWayBill?.transaction_type === "Bill/Dispatch To"
              ? 3
              : 4,
      transporter_document_date: generateEWayBill?.transporter_document_date
        ? reverseDate(generateEWayBill?.transporter_document_date)
        : null,
      client_code,
      invoice_id: +eWayBillInvoiceId,
    };
    dispatchGetGenerateEWayBillAction(finalData);
  };
  return (
    <>
      <div className="col-md-12">
        <Row>
          <Col lg={4}>
            <h6 style={{ margin: 0, fontSize: "18px", fontWeight: 500 }}>
              Sales Invoices
            </h6>
            {!fetching && (
              <span
                style={{ color: "#7c8db0", fontSize: "13px", fontWeight: 500 }}
              >
                Total {revenueInvoicesTotal} entries found
              </span>
            )}
          </Col>

          <Col
            lg={8}
            className="text-right d-flex flex-row"
            style={{ justifyContent: "flex-end" }}
          >
            <div className="mr-2 w-auto position-relative">
              <span style={{ position: "absolute", top: "8px", left: "13px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                value={searchData}
                placeholder="Search"
                onChange={(e: any) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
              />
            </div>
            {isBulkUploadSalesPresent && (
              <div
                onClick={() => {
                  dispatchResetMessageAndSuccess();
                  history.push({
                    pathname: `/invoice-generation/bulk-upload/${client_code}?type=revenues`,
                    state: { client_code, company_name },
                  });
                }}
                className="btn btn-outline mr-2"
                style={{
                  width: "200px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fas fa-file-upload"></i>&nbsp;Bulk&nbsp;Upload
              </div>
            )}
            <PaymentSorting
              setAllPaymentStatus={setAllPaymentStatus}
              allPaymentStatus={allPaymentStatus}
              options={FILTER_PAYMENT_FORMAT_PURCHASE}
              history={history}
            />

            <div className="ml-1">
              <Filter
                attachment={attachment}
                approved={approved}
                settingApproval={settingApproval}
                settingAttachment={settingAttachment}
                setAttachment={setAttachment}
                setApproved={setApproved}
                setClearFilter={setClearFilter}
                setOffset={setOffset}
                approvalValue={approvalValue}
                attachmentValue={attachmentValue}
                setApprovalValue={setApprovalValue}
                setAttachmentValue={setAttachmentValue}
                setData={setData}
                handleDeleteFiltersInHistory={handleDeleteFiltersInHistory}
                comment={comment}
                setComment={setComment}
                commentValue={commentValue}
                setCommentValue={setCommentValue}
                settingComment={settingComment}
                filterStartDate={filterStartDate}
                filterEndDate={filterEndDate}
                setFilterStartDate={setFilterStartDate}
                setFilterEndDate={setFilterEndDate}
                setFilterEndDateValue={setFilterEndDateValue}
                setFilterStartDateValue={setFilterStartDateValue}
                filterStartDateValue={filterStartDateValue}
                filterEndDateValue={filterEndDateValue}
                filterInvoiceStartDate={filterInvoiceStartDate}
                filterInvoiceEndDate={filterInvoiceEndDate}
                setFilterInvoiceEndDate={setFilterInvoiceEndDate}
                setFilterInvoiceStartDate={setFilterInvoiceStartDate}
                //
                filterInvoiceStartDateValue={filterInvoiceStartDateValue}
                filterInvoiceEndDateValue={filterInvoiceEndDateValue}
                setFilterInvoiceEndDateValue={setFilterInvoiceEndDateValue}
                setFilterInvoiceStartDateValue={setFilterInvoiceStartDateValue}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
                history={history}
                isOCRFilter={isOCRFilter}
                setIsOCRFilter={setIsOCRFilter}
                isOCRFilterValue={isOCRFilterValue}
                setIsOCRFilterValue={setIsOCRFilterValue}
              />
            </div>
            <div className="ml-2">
              <Sorting
                invoiceDate={invoiceDate}
                setInvoiceDate={setInvoiceDate}
                invoiceNumber={invoiceNumber}
                setInvoiceNumber={setInvoiceNumber}
                invoiceDateValue={invoiceDataValue}
                setInvoiceDateValue={setInvoiceDateValue}
                invoiceNumberValue={invoiceNumberValue}
                setInvoiceNumberValue={setInvoiceNumberValue}
                allSorting={allSorting}
                setAllSorting={setAllSorting}
                allSortingValue={allSortingValue}
                setAllSortingValue={setAllSortingValue}
                history={history}
              />
            </div>

            <div className="ml-2">
              {isDownloadSalesReportPresent && (
                <DownloadInvoiceGenerationReports
                  type="revenues"
                  client_code={client_code}
                  token={token}
                  company_name={company_name}
                  attachment={attachment}
                  approved={approved}
                  invoiceDate={
                    invoiceDate === "invoice_date_desc"
                      ? "desc"
                      : invoiceDate === "invoice_date_asc"
                        ? "asc"
                        : ""
                  }
                  invoiceNumber={
                    invoiceNumber === "invoice_number_desc"
                      ? "desc"
                      : invoiceNumber === "invoice_number_asc"
                        ? "asc"
                        : ""
                  }
                  paymentStatus={paymentStatus}
                  searchData={searchData}
                  isInvoiceOcrCreated= {isOCRFilterValue}
                />
              )}
            </div>

            {isLockRevenuePresent ? (
              <div className="ml-2">
                <LockEntryModal
                  handleSubmitLockEntry={handleSubmitLockEntry}
                  lockedEntriesDate={lockedRevenueEntriesDate}
                />
              </div>
            ) : null}
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <MultiSelect data={multiSelectData} onClose={onClose} />
          </Col>
        </Row>
      </div>
      {fetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      ) : (
        <div className="jobsType" style={{ overflowX: "auto" }}>
          <table className="table table-bordered thead-light">
            <thead
              className="text-start sticky-table-header"
              style={{ fontSize: "13px" }}
            >
              <TableHeader
                tableHeader={REVENUES_INVOICES_LIST_HEADERS}
                extraHeader
              />
            </thead>
            <tbody>
              <RevenueInvoicesListTableData
                isEinvoice={isEinvoice}
                data={data}
                pdfFetching={pdfFetching}
                deleteInvoice={deleteInvoice}
                handleShowConfirmationModal={handleShowConfirmationModal}
                tableHeader={REVENUES_INVOICES_LIST_HEADERS}
                loginData={loginData}
                handleRedirectToEditForm={handleRedirectToEditForm}
                handleRedirectToCopyForm={handleRedirectToCopyForm}
                handleGeneratePdf={handleGeneratePdf}
                isEditSalesPresent={isEditSalesPresent}
                isRevenueListCommentPresent={isRevenueListCommentPresent}
                isDownloadSalesPresent={isDownloadSalesPresent}
                toggleInvoiceHistory={toggleInvoiceHistory}
                isRevenueHistory={isRevenueHistory}
                handleToggleInvoiceCommentsModal={
                  handleToggleInvoiceCommentsModal
                }
                isAddSalesPresent={isAddSalesPresent}
                setDownloadRevenuesData={setDownloadRevenuesData}
                handleNewInvoicePdf={handleNewInvoicePdf}
                handleSetInvoiceData={handleSetInvoiceData}
                isViewSalesInvoicePresent={isViewSalesInvoicePresent}
                currencySign={currencySign}
                lockedRevenueEntriesDate={lockedRevenueEntriesDate}
                isDeleteRevenueEntries={isDeleteRevenueEntries}
                togglePreviewEInvoice={togglePreviewEInvoice}
                togglePreviewEWayBill={togglePreviewEWayBill}
                handleSubmitPreviewEinvoice={handleSubmitPreviewEinvoice}
                setShowSendInvoiceEmailModal={setShowSendInvoiceEmailModal}
                handleSendInvoiceEmailData={handleSendInvoiceEmailData}
                isPreviewEInvoicePresent={isPreviewEInvoicePresent}
                handleCustomerSuplierDetailsData={
                  handleCustomerSuplierDetailsData
                }
                isEWayBillPresent={isEWayBillPresent}
              />
              <ScrollToTop />
              {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            </tbody>
          </table>
        </div>
      )}
      {showPreViewModal && (
        <RevenuePdfPreviewModal
          modal={showPreViewModal}
          toggleModal={handleShowPdfPreviewModal}
          pdfTemplatesNames={pdfTemplatesNames}
          pdfTemplateSelected={pdfTemplateSelected}
          setPdfTemplateSelected={setPdfTemplateSelected}
          currencySign={
            customerSingleInvoiceData?.primary_details?.currency?.currencySign
              ? customerSingleInvoiceData?.primary_details?.currency
                ?.currencySign
              : currencySign
          }
          customerSingleInvoiceData={downloadRevenuesData}
          pdfInvoiceId={pdfInvoiceId}
          clientCode={client_code}
          currencyShortForm={
            customerSingleInvoiceData?.primary_details?.currency
              ?.currencyShortForm
              ? customerSingleInvoiceData?.primary_details?.currency
                ?.currencyShortForm
              : currencyShortForm
          }
        />
      )}

      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleShowConfirmationModal(deleteInvoiceId);
          }}
          isOpen={showConfirmationModal}
          title={"Delete Sales"}
          message={`Are you sure you want to Delete`}
          confirmButtonText={"Delete"}
          onPressConfirm={() => {
            deleteInvoice(deleteInvoiceId);
            handleShowConfirmationModal(deleteInvoiceId);
          }}
        />
      )}

      {showPreviewEinvoiceModal && (
        <EinvoiceModal
          success={success}
          eInvoiceAt={eInvoiceAt}
          eInvoiceError={eInvoiceError}
          isOpen={showPreviewEinvoiceModal}
          data={eInvoiceReviewData}
          togglePreviewEInvoice={togglePreviewEInvoice}
          handleSubmitPreviewEinvoice={handleSubmitPreviewEinvoice}
          fetching={fetching}
          isEinvoicePresent={isEinvoicePresent}
          cancelComment={cancelComment}
          setCancelComment={setCancelComment}
          eInvoiceRadioValue={eInvoiceRadioValue}
          setEinvoiceRadioValue={setEinvoiceRadioValue}
          isGenerateEInvoicePresent={isGenerateEInvoicePresent}
          isCancelEInvoicePresent={isCancelEInvoicePresent}
        />
      )}
      {showPreviewEWayBillModal && (
        <EWayBillModal
          success={success}
          eWayBillError={eWayBillError}
          isOpen={showPreviewEWayBillModal}
          data={eWayBillReviewData}
          togglePreviewEWayBill={togglePreviewEWayBill}
          fetching={fetching}
          isEWayPresent={isEWayPresent}
          setIsEWayPresent={setIsEWayPresent}
          generateEWayBill={generateEWayBill}
          setGenerateEWayBill={setGenerateEWayBill}
          handleEWayBillGenerate={handleEWayBillGenerate}
          cancelEWayBillComment={cancelEWayBillComment}
          setCancelEWayBillComment={setCancelEWayBillComment}
          eWayBillRadioValue={eWayBillRadioValue}
          setEWayBillRadioValue={setEWayBillRadioValue}
          eWayBillAt={eWayBillAt}
          handleCancelEWayBill={handleCancelEWayBill}
          isEWayBillGenerate={isEWayBillGenerate}
          isEWayBillCancel={isEWayBillCancel}
          isEWayBillExtend={isEWayBillExtend}
          isEWayBillDownload={isEWayBillDownload}
          message={message}
          clientCode={client_code}
          eWayBillInvoiceId={eWayBillInvoiceId}
          type="revenues"
          token={token}
        />
      )}

      {
        <InvoiceHistory
          isRight={true}
          isOpen={isInvoiceHistory}
          onClose={toggleInvoiceHistory}
          history={invoiceHistoryData}
          clientCode={client_code}
          fetching={bulkUploadFetching}
          handleLoadMore={handleLoadMore}
          invoiceHistoryLimit={invoiceHistoryLimit}
          invoiceHistoryCount={invoiceHistoryCount}
          invoiceHistoryOffset={invoiceHistoryOffset}
        />
      }
      {showModal && (
        <ViewEditCustomerSuplierModal
          isOpen={showModal}
          setRedirectToCustomerSuplier={setRedirectToCustomerSuplier}
          fetching={customerSuplierFetching}
          client_code={client_code}
          company_name={company_name}
          isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
          toggle={handleCustomerSuppliertoggle}
          singleCustomerSupplier={singleCustomerSupplier}
          currencySign={currencySign}
        />
      )}

      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  fetching: state.invoiceGeneration.fetching,
  pdfFetching: state.invoiceGeneration.pdfFetching,
  success: state.invoiceGeneration.success,
  allRevenueInvoicesList: state.invoiceGeneration.allRevenueInvoicesList,
  revenueInvoicesTotal: state.invoiceGeneration.revenueInvoicesTotal,
  bulkUploadFetching: state.invoiceGeneration.bulkUploadFetching,
  statusCode: state.invoiceGeneration.statusCode,
  error: state.invoiceGeneration.error,
  message: state.invoiceGeneration.message,
  singleInvoiceDetails: state.invoiceGeneration.singleInvoiceDetails,
  mappedRevenueColumnsList: state.invoiceGeneration.mappedRevenueColumnsList,
  lockedRevenueEntriesDate: state.invoiceGeneration.lockRevenueEntriesDate,
  eInvoiceReviewData: state.invoiceGeneration.eInvoiceReviewData,
  eWayBillReviewData: state.invoiceGeneration.eWayBillReviewData,
  eInvoiceData: state.invoiceGeneration.eInvoiceData,
  eInvoiceError: state.invoiceGeneration.eInvoiceError,
  eWayBillError: state.invoiceGeneration.eWayBillError,
  customerSingleInvoiceData: state.invoiceGeneration.customerSingleInvoiceData,
  currencyShortForm: state.auth.currencyShortForm,
  invoiceHistoryCount: state.invoiceGeneration.invoiceHistoryCount,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  customerSuplierFetching: state.clientSettings.fetching,
  mappedPdfTemplate: state.clientSettings.mappedPdfTemplate,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetRevenueInvoicesListAction: () =>
    dispatch(resetRevenueInvoicesList()),
  dispatchResetSingleInvoiceDetails: () =>
    dispatch(resetSingleInvoiceDetails()),
  dispatchGetAllRevenuInvoicesListAction: (
    data: GetAllRevenueInvoicesListPayloadType
  ) => dispatch(getAllRevenuInvoicesListAction(data)),
  dispatchGetPreviewEinvoiceData: (data: EinvoiceDataPayloadType) =>
    dispatch(getReviewEinvoiceDataAction(data)),
  dispatchGetPreviewEWayBillData: (data: EWayBillDataPayloadType) =>
    dispatch(getReviewEWayBillDataAction(data)),
  dispatchGetSingleInvoiceAction: (data: GetCommentPayloadType) =>
    dispatch(getInvoiceCustomerInvoiceDownload(data)),
  dispatchResetSingleInvoiceAction: () => dispatch(resetSingleInvoiceData()),
  dispatchPostEinvoiceDataAction: (data: EinvoiceDataPayloadType) =>
    dispatch(postEinvoiceDataAction(data)),
  dispatchPostCancelEinvoiceDataAction: (data: EinvoiceRevertDataPayloadType) =>
    dispatch(postCancelEinvoiceDataAction(data)),
  dispatchResetPreviewEinvoiceData: () => dispatch(resetEinvoiceReviewData()),
  dispatchResetInvoiceGenerationErrorAction: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchResetMessageAndSuccess: () => dispatch(resetSuccess()),
  dispatchResetInvoiceGenerationSuccessAction: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetRevenueInvoicesTotal: () =>
    dispatch(resetRevenueInvoicesTotal()),
  dispatchResetEinvoiceError: () => dispatch(resetEinvoiceError()),
  dispatchResetEWayBillError: () => dispatch(resetEWayBillError()),
  dispatchGetSingleInvoiceDetailsAction: (data: any) =>
    dispatch(getSingleInvoiceDetailsAction(data)),
  dispatchDeleteInvoice: (data: DeleteInvoicesListPayloadType) =>
    dispatch(deleteInvoiceAction(data)),
  dispatchResetInvoiceGenerationOverDueEmailSuccess: () =>
    dispatch(resetInvoiceGenerationOverDueEmailSuccess()),
  dispatchGetAllTypesLedgerListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllTypesWithTaxListAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchResetSingleCustomerSupplier: () =>
    dispatch(resetSingleCustomerSupplier()),
  dispatchResetEWayBillReviewData: () => {
    dispatch(resetEWayBillReviewData());
  },
  dispatchGetGenerateEWayBillAction: (data: GenerateEWayBillPayloadType) =>
    dispatch(getGenerateEWayBillAction(data)),
  dispatchCancelEWayBillDataAction: (data: EWayBillCancelDataPayloadType) =>
    dispatch(cancelEWayBillDataAction(data)),
  dispatchGetMappedPdfTemplateAction: (
    data: GetPdfMappingTemplatePayloadType
  ) => dispatch(getMappedPdfTemplateAction(data)),
  dispatchResetMappedPdfTemplateAction: () =>
    dispatch(resetMappedPdfTemplate()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RevenueInvoicesList);
